/**
 * @generated SignedSource<<8786c11a13b4802c8cc3b8b429d61225>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnonymousContributionFormBanner_anonymousMode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forceAnonymousContributions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toggleAnonymousMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WithAnonymousMode",
  "abstractKey": "__isWithAnonymousMode"
};

node.hash = "03c77ff5c8ad0a3dd9a7ce7a2a4b6d43";

module.exports = node;
